import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TalkShowIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M11.993 2.883A1 1 0 0011 2H2l-.117.007A1 1 0 001 3v5l.007.117A1 1 0 002 9l.117-.007A1 1 0 003 8V4h7v4l.007.117A1 1 0 0012 8V3l-.007-.117z"
                        }),
                        _jsx("path", {
                            d: "M21.696 6l-4.33-2.5A1 1 0 0016 3.866l-1.5 2.598a1 1 0 00.366 1.366l4.33 2.5a1 1 0 001.366-.366l1.5-2.598A1 1 0 0021.696 6zM19.83 7.232l-.5.866-2.598-1.5.5-.866 2.598 1.5z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M3.55 17.58a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.906zM7.148 16.078a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM11.148 16.078a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM15.55 17.58a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.906zM19.148 16.078a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM1.55 21.15a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM9.148 19.648a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM13.148 19.648a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM17.55 21.15a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM21.148 19.648a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM5.148 19.648a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM22.2 3.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM5.1 7.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM5.243 12.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM9.243 12.55a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM13.243 12.55a1.1 1.1 0 101.906 1.1 1.1 1.1 0 00-1.906-1.1zM17.646 14.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM8.296 7.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        })
                    ]
                })
            })
        ]
    });
};
TalkShowIcon.isCarinaIcon = true;
export default TalkShowIcon;
